import { Box, Typography } from '@mui/material';

interface TransformItemProps {
  title: string;
  subtitle: string;
  image: string;
}

function TransformItem({ title, subtitle, image }: TransformItemProps) {
  return (
    <Box
      sx={{
        border: '1px solid rgba(35, 38, 49, 0.10)',
        textAlign: 'left',
        WebkitTapHighlightColor: 'transparent',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: '25px 20px',
        gap: '5px',
        borderRadius: '16px',
        overflow: 'hidden',
        '& > .background-image': {
          position: 'absolute',
          top: 0,
          right: 0,
          height: '100%',
          objectFit: 'cover',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          position: 'relative',
          zIndex: 1,
          maxWidth: '189px',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Avenir Next',
            fontWeight: 600,
            fontSize: '16px',
            color: '#232631',
          }}
        >
          {title}
        </Typography>
      </Box>
      <Typography
        sx={{
          maxWidth: '189px',
          lineHeight: '22px',
          position: 'relative',
          zIndex: 1,
          fontFamily: 'Avenir Next',
          fontWeight: 400,
          fontSize: '14px',
          color: '#8C8E96',
        }}
      >
        {subtitle}
      </Typography>

      <img className="background-image" src={image} alt="decor" />
    </Box>
  );
}

export default TransformItem;
